import { Planzone, StrategicAxis, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editStrategicAxis(httpClient: HttpClient) {
  return (
    planzone: Planzone,
    strategicAxis: StrategicAxis,
    nextStrategicAxis: StrategicAxis,
  ) =>
    new Promise<Identifiable<StrategicAxis>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<StrategicAxis>>({
          endpoint: `/strategicAxeses/${strategicAxis.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            planzone: `planzone/${planzone.uuid}`,
            ...nextStrategicAxis,
          },
        })
        .then((updatedStrategicAxis) => resolve(updatedStrategicAxis))
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { editStrategicAxis };
